<template>
<div style="justify-content: center; display: flex; flex-direction: column;">
  <h1 style="color: brown;margin-bottom: 0px;">价值投资收益计算器</h1>
  <h2 style="color: brown;">散户乙：把每股盈利作为自己投资的盈利，把现金分红作为自己的自由现金流</h2>
  <p style="margin-bottom: 10px;">这个应用程序可以帮助计算您的股票投资组合的长期预期收益。<br>您可以添加股票并输入购买价格、股票数量、股票分红和股票业绩。<br>然后，您可以生成一个表格，该表格显示您的股票投资的收益。
  <br><span style="font-size: 20px;color: crimson;">从长远来看，您的投资组合收益等于公司的业绩增长率和分红</span></p>
  <div class="contact">
            <p>本域名可出售，联系邮箱：</p>
            <a href="mailto:contact@maigubao.com">contact@maigubao.com</a>
            
            <h2><p>本站地址： 买股宝</p><a href="https://www.maigubao.com">www.maigubao.com</a></h2>
        </div>
</div>
  <router-view/>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}

// 确保html和body也填充满整个视口
html, body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
}
</style>
